import { motion } from "framer-motion";
import styled from "styled-components";

export const StyledBorder = styled(motion.div)`
	border: 1px solid #333;
	margin-top: ${({marginTop}) => marginTop};
`;